// extracted by mini-css-extract-plugin
export default {"back_btn":"History_back_btn__VEES2","ticker":"History_ticker__3NsHA","price":"History_price__eLrIG"};